<template>
    <PageView>
        <a-card title="列表">
            <a-button type="primary" slot="extra" @click="$router.push({ name: `commodityEdit` })">添加商品</a-button>
            <a-row :gutter="10" class="inputGroup" style="margin-bottom:10px">
                <!--   <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-range-picker v-model="time" :placeholder="['开始时间', '结束时间']" @change="getListTwo"/>
                </a-col>-->
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.name" placeholder="商品名称" @keyup.enter="getListTwo" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-select allowClear v-model="searchData.cat_id" style="width:100%" placeholder="请选择分类">
                        <a-select-option :value="value.id" v-for="(value, key) in fenlei" :key="key">{{
                value.name
            }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="24" :md="12" :lg="12" :xl="12">
                    <a-button-group>
                        <a-button type="primary" :loading="loading" @click="getListTwo">确定筛选</a-button>
                    </a-button-group>
                    
                    <a-button-group style="margin-left:10px">
                        <a-button type="primary" :loading="loading" @click="getListInit">重置</a-button>
                    </a-button-group>
                    <!-- <a-button-group>
                        <a-button type="primary" :loading="loading" @click="exportExcel">导出</a-button>
                    </a-button-group>  -->
                    <!-- <a-button-group>
                        <a-button
                            type="primary"
                            style="margin-left:20px"
                            :loading="loading"
                            @click="changeBanner(id, 'DeleteGoods', '批量删除')"
                            >批量删除</a-button
                        >
                    </a-button-group>
                    <a-button-group>
                        <a-button
                            style="margin-left:20px"
                            type="primary"
                            :loading="loading"
                            @click="changeBannerS(id, 'PiTop', '批量上架', 1)"
                            >批量上架</a-button
                        >
                    </a-button-group>
                    <a-button-group>
                        <a-button
                            type="primary"
                            style="margin-left:20px"
                            :loading="loading"
                            @click="changeBannerS(id, 'PiTop', '批量下架', 2)"
                            >批量下架</a-button
                        >
                    </a-button-group> -->
                </a-col>
                <!-- <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    
                </a-col> -->
            </a-row>
            <a-table :loading="loading" :columns="columns" :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }" @change="changePagination" bordered
                :scroll="{ x: true }">
            </a-table>
        </a-card>

        <a-modal v-model="visible" title="查看图片" @ok="visible = false">
            <img :src="viewImg" style="width: 100%;" alt="" />
        </a-modal>
        <a-modal v-model="visible1" title="查看轮播图" @ok="visible1 = false">
            <a-carousel arrows>
                <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
                    <a-icon type="left-circle" />
                </div>
                <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
                    <a-icon type="right-circle" />
                </div>
                <div v-for="(i, key) in imagex" :key="key">
                    <img :src="i" style="width: 100%;height:300px;" alt="" />
                </div>
            </a-carousel>
            <!-- {{ imagex }} -->
            <!--  <div slot="prevArrow" slot-scope="props" class="custom-slick-arrow" style="left: 10px;zIndex: 1">
                <a-icon type="left-circle" />
            </div>
            <div slot="nextArrow" slot-scope="props" class="custom-slick-arrow" style="right: 10px">
                <a-icon type="right-circle" />
            </div>
            <a-carousel>
                <div v-for="(i, key) in imagex" :key="key">
                    <img :src="i" style="width: 100%;height:300px;" alt="" />
                </div>
            </a-carousel> -->
        </a-modal>
    </PageView>
</template>

<script type="text/jsx">
import Goods from '@api/Goods'
import ExportJsonExcel from "js-export-excel"
export default {
    name: 'dealList',
    data() {
        return {
            loading: true,
            visible1: false,
            imagex: [],
            selectedRowKeys: [], // Check here to configure the default column
            columns: [
                {
                    title: '店铺名称',
                    dataIndex: 'shop_name',
                    customRender: (v) => {
                        console.log('vvvvvvv', v)
                        return v ? v : '暂无'
                    }
                },
                {
                    title: '商品名称',
                    dataIndex: 'name',
                    customRender: (v) => {
                        return v ? v : '暂无'
                    }
                },
                {
                    title: '分类名称',
                    dataIndex: 'cat_name',
                    customRender: (v) => {
                        return v ? v : '暂无'
                    }
                },
                {
                    title: '商品编号',
                    dataIndex: 'goods_num',
                    customRender: (v) => {
                        return v ? v : '暂无'
                    }
                },
                {
                    title: '商品图片',
                    dataIndex: 'img',
                    customRender: (v) => {
                        return v ? <img src={v} style="width:100px;height:100px;cursor: pointer" alt="" onClick={() => {
                            this.visible = true;
                            this.viewImg = v;
                        }
                        } /> : '暂无'
                    }
                },
                {
                    title: '热销状态',
                    dataIndex: 'hot',
                    customRender: (v) => {
                        if (v == 1) {
                            return "否"
                        } else {
                            return "是"
                        }
                    }
                },
                {
                    title: '上架状态',
                    dataIndex: 'putaway',
                    customRender: (v) => {
                        if (v == 1) {
                            return "上架"
                        } else {
                            return "下架"
                        }
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    <a-menu-item onClick={() => {
                                        this.$router.push({ name: "commodityEdit", query: { id: v.id } })
                                    }}>编辑
                                    </a-menu-item>
                                    <a-menu-item onClick={() => {
                                        this.changeBanner(v.id, "deleteGoods", "删除")
                                    }}>删除
                                    </a-menu-item>

                                    <a-menu-item onClick={() => {
                                        if (v.photo) {
                                            this.visible1 = true
                                            this.imagex = v.photo.split(',')
                                        } else {
                                            //  弹出提示
                                        }
                                    }}>查看轮播图
                                    </a-menu-item>
                                </a-menu>
                                <a-button>操作 <a-icon type="down" /></a-button>
                            </a-dropdown>
                        )
                    }
                }
            ],
            data: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            searchData: {
                cat_id: undefined,
                name: '',
            },
            time: [],
            orderStatus: [],
            visible: false,
            viewImg: '',
            fenlei: [],  //  获取分类列表
            brand: [],
            id: '',
        }
    },
    activated() {
        this.init()
        this.getList()
    },
    methods: {
        exportExcel(){
            const datas = this.data ? this.data : '';//导出的数据
            console.log('data',datas);
            const option = {};//定义一个容器，存储Excel文件信息
            const dataTable = [];//定义一个容器，存储Excel表格每行数据
            if (datas) {
                for (const i in datas) {  //循环数据
                    //obj存储的是行的信息
                    const obj = {
                        '店铺名称': datas[i].shop_name,
                        '商品名称': datas[i].name,
                        '分类名称': datas[i].cat_name,
                        '商品编号': datas[i].goods_num,
                        '商品图片': datas[i].img,
                        '热销状态': datas[i].hot == 1 ? '否' : '是',
                        '上架状态': datas[i].putaway == 1 ? '上架' : '下架' ,
                    }
                    dataTable.push(obj)
                }
            }

            // 文件名称
            option.fileName = '商品列表'
            option.datas = [
                {
                    sheetData: dataTable,
                    sheetName: 'sheet',
                    sheetFilter: ['店铺名称', '商品名称', '分类名称', '商品编号', '商品图片', '热销状态', '上架状态'],
                    sheetHeader: ['店铺名称', '商品名称', '分类名称', '商品编号', '商品图片', '热销状态', '上架状态'],
                }
            ];
            //生成Excel文件对象
            const toExcel = new ExportJsonExcel(option);
            //下载到本地
            toExcel.saveExcel();
        },
        getListInit() {
            this.searchData.cat_id = undefined
            this.searchData.name = ''
            this.current = 1
            this.getList()
        },
        onSelectChange(selectedRowKeys, e) {
            let arr = []
            for (let i = 0; i < e.length; i++) {
                arr.push(e[i].id)
            }
            this.selectedRowKeys = selectedRowKeys;
            this.id = arr.join(',')
            console.log(arr.join(','))
        },
        init() {
            Goods.Cats().then(res => {
                this.fenlei = res.result
            })
        },
        changeBanner(id, methods, title) {
            this.$confirm({
                title: `${title}`,
                content: `确定要${title}此项吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Goods[methods]({ id }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        changeBannerS(id, methods, title, type) {
            console.log(id)
            if (!id) {
                console.log("停止")
                this.$notification.warning({
                    message: '提示',
                    description: "请选择批量处理的商品"
                })
                return
            }
            this.$confirm({
                title: `${title}`,
                content: `确定要${title}此项吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Goods[methods]({ id: id, type: type }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        getListTwo() {
            this.current = 1
            this.getList()
        },
        getList() {
            this.loading = true
            Goods.GoodsList({
                page: this.current,
                num: this.pageSize,
                ...this.searchData,
                // begin: Date.parse(this.time[0]) / 1000 || undefined,
                // last: Date.parse(this.time[1]) / 1000 || undefined
            }).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        changePagination(pagination) {
            Object.keys(pagination).forEach(val => {
                this[val] = pagination[val]
            })
            this.getList()
        },
        delObj() {
            let obj = { ...orderStatus }
            this.$delete(obj, "-3")
            this.$delete(obj, "-4")
            console.log(orderStatus)
            return obj
        },



    }
}
</script>
<style scoped>
/* For demo */
.ant-carousel>>>.slick-slide {
    text-align: center;
    background: #364d79;
    overflow: hidden;
}

.ant-carousel>>>.custom-slick-arrow {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
}

.ant-carousel>>>.custom-slick-arrow:before {
    display: none;
}

.ant-carousel>>>.custom-slick-arrow:hover {
    opacity: 0.5;
}

.ant-carousel>>>.slick-slide h3 {
    color: #fff;
}
</style>
